var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"uploadHistoryModal","size":"xl","visible":"","ok-only":"","ok-title":"Close","title":"Upload History"},on:{"hide":function($event){return _vm.$emit('close')}}},[_c('div',[_c('UploadHistoryTable',{attrs:{"table-ids":_vm.tableIds}})],1),_c('content-spinner',{attrs:{"show":_vm.uploadHistoryLoadingState}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }